module.exports = __webpack_public_path__ + "img/ic_empty.1e49eeff.svg";